import { z } from 'zod';

export const ProdutoMarcaSchema = z.object({
    prm_data_insercao: z.string(),
    prm_descricao: z.string(),
    prm_empresa_idpk: z.number().int(),
    prm_idpk: z.number().int(),
    prm_ultima_alteracao: z.string(),
    qtde_produtos: z.number().int(),
});

export type ProdutoMarca = z.infer<typeof ProdutoMarcaSchema>;

export const ProdutoMarcaSelectSchema = ProdutoMarcaSchema.pick({
    prm_descricao: true,
    prm_idpk: true,
});

export type ProdutoMarcaSelectItem = z.infer<typeof ProdutoMarcaSelectSchema>;

export type ProdutoMarcaBody = Pick<ProdutoMarca, 'prm_descricao'>;
